<template>
  <div class="page">
    <!-- Setup header (with searchbar, filters and title) -->
    <TekenaarsHeader @showVoegTekenaarToeModal="$emit('showVoegTekenaarToeModal')" />

    <div class="page-wrapper" >
      <ItemsHeader />
      <div
        v-for="tekenaar in orderBy(filteredTekenaars, 'aantalOpdrachten', aantalOpdrachtenDirection)"
        :key="tekenaar.id"
        v-on:click="$emit('select-tekenaar', tekenaar.id)"
      >
        <TekenaarsItem :tekenaar="tekenaar" />
      </div>
    </div>
   
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import store from '../../../store';

import Vue2Filters from 'vue2-filters';

import TekenaarsHeader from './TekenaarsHeader';
import TekenaarsItem from './TekenaarsItem';
import ItemsHeader from './ItemsHeader';


export default {
  name: 'tekenaars',
  components: {
    TekenaarsHeader,
    TekenaarsItem,
    ItemsHeader,
    // 
  },
  mixins: [Vue2Filters.mixin],
  data() {
    return {
      aantalOpdrachtenDirection: -1,
    };
  },
  computed: {
    ...mapGetters(['allTekenaars', 'allOpdrachten']),
    showNewProfiles(){
      return store.state.showNewProfiles
    },
    disciplines()  {
      return store.state.disciplines_lowercase
    },
    
    newProfiles() {
      return this.$store.state.userAccounts
    },
    newProfilesFiltered(){
      return this.newProfiles.filter((tekenaar) => {
        return `${tekenaar.userProfile?.voornaam?.toLowerCase()} ${tekenaar.userProfile?.achternaam?.toLowerCase()}`.includes(store.state.tekFilters.name.toLowerCase());
        }).filter((tekenaar) => {
          if (this.selectedDiscipline) return tekenaar.userProfile?.disciplines?.includes(this.selectedDiscipline)
          return tekenaar
        }).filter((tekenaar) => {
          if (this.selectedWerkgebied) return tekenaar.userProfile?.werkgebied?.includes(this.selectedWerkgebied)
          return tekenaar
        }).filter((tekenaar) => {
          if (this.selectedTekenprogramma) return tekenaar.userProfile?.tekenprogrammas?.includes(this.selectedTekenprogramma)
          return tekenaar
        })
    },
    filteredTekenaars() {
      let Nieuwelijst = [];

      const ting = this.allTekenaars
        .filter((tekenaar) => {
          return tekenaar.naam.toLowerCase().includes(store.state.tekFilters.name.toLowerCase());
        })
        .filter((tekenaar) => {
          return tekenaar.email.toLowerCase().includes(store.state.tekFilters.email.toLowerCase());
        })
        .filter((tekenaar) => {
          return tekenaar.telefoonnummer.toLowerCase().includes(store.state.tekFilters.telefoonnummer.toLowerCase());
        })
        .filter((tekenaar) => {
          if (store.state.tekFilters.disciplines == '') {
            return tekenaar;
          } else {
            return tekenaar.disciplines.includes(store.state.tekFilters.disciplines);
          }
        })
        .filter((tekenaar) => {
          return tekenaar.bedrijfsnaam.toLowerCase().includes(store.state.tekFilters.bedrijfsnaam.toLowerCase());
        })
        .filter((tekenaar) => {
          return tekenaar.woonplaats.toLowerCase().includes(store.state.tekFilters.woonplaats.toLowerCase());
        })
        .filter((tekenaar) => {
          return tekenaar.tekenprogramma.toLowerCase().includes(store.state.tekFilters.tekenprogramma.toLowerCase());
        });

      ting.forEach((element) => {
        let aantalOpdrachten = this.opdrachtenVanTekenaar(element.id).length;
        let newElement = {
          ...element,
          aantalOpdrachten: aantalOpdrachten
        };
        Nieuwelijst.push(newElement);
      });

      return Nieuwelijst;
    },
    showTekFilters() {
      return store.state.showTekFilters;
    }
  },
  methods: {
    
    toggleShowTekFilters() {
      store.commit('toggleShowTekFilters', this.showTekFilters);
    },
    opdrachtenVanTekenaar(tekenaarsid) {
      return this.allOpdrachten.filter((opdracht) => {
        if (tekenaarsid == opdracht.tekenaarsid) {
          return opdracht;
        }
      });
    }
  }
};
</script>

<style lang="sass" scoped>
.filter
  appearance: none
  outline: none
  border: none
  padding: 14px 18px
  font-size: 15px
  border-radius: 1000px
  border: 1px solid rgba(0, 0, 0, 0.1)
  background-color: black
  color: white
  font-weight: 500
  cursor: pointer


</style>

<style>
.filtertoggle {
  /* padding-bottom: 20px; */
  display: flex;
}

.filter {
  padding-left: 6px;
}
</style>


<style lang="sass" scoped>
.filtersWrapper
  display: flex
  align-items: center
</style>
